var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// Core
import React from 'react';
// Utils
import { isMobile } from '../../utils/media';
// Styles
import './arrow.scss';
// Component Core function
import { checkChildrenAreAvailable, checkContentIsAvailable, checkImageIsAvailable, checkLabelIsAvailable, getLinkProps, updateState, } from './Link.functions';
import Wrapper from './Wrapper';
/**
 * *Link component*, handle Link display with sub listing diplay.
 */
var Link = /** @class */ (function (_super) {
    __extends(Link, _super);
    /**
     * Link component constructor
     * @param props
     */
    function Link(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Launch update state if props changed
         *
         * @param oldProps
         * @param newProps
         */
        _this.updateState = function (oldProps, newProps) {
            if (oldProps !== newProps) {
                _this.setState(updateState(newProps));
            }
        };
        /**
         * Handle click
         */
        _this.onClickAction = function (evt) {
            if (_this.props.onClickAction) {
                _this.props.onClickAction(_this.props.linkId, evt);
            }
        };
        /**
         * Apply active effect on row mobile
         */
        _this.activeRow = function () {
            if (isMobile()) {
                var _a = _this.state, Tag = _a.Tag, contentProps = _a.contentProps;
                var index = _this.props.index;
                if (_this.props.onOver) {
                    _this.props.onOver(React.createElement(Tag, __assign({}, contentProps)), index);
                }
            }
        };
        /**
         * Handle keyPress
         *
         * @param evt
         */
        _this.onKeyPress = function (evt) {
            if (evt.keyCode === 40 || evt.keyCode === 9) {
                _this.activeRow();
            }
        };
        _this.state = updateState(__assign({}, props));
        return _this;
    }
    /**
     * Update component
     *
     * @param props
     */
    Link.prototype.componentDidUpdate = function (props) {
        this.updateState(this.props, props);
    };
    /**
     * Render Link method
     */
    Link.prototype.render = function () {
        var _this = this;
        var _a = this.props, label = _a.label, children = _a.children, isOpen = _a.isOpen, image = _a.image;
        var _b = this.state, Tag = _b.Tag, rowProps = _b.rowProps, contentProps = _b.contentProps, listProps = _b.listProps;
        return (React.createElement("li", __assign({}, rowProps),
            checkContentIsAvailable(image, label) ? (React.createElement(Wrapper, { type: Tag, content: contentProps, handleClick: this.onClickAction },
                checkImageIsAvailable(image) ? (React.createElement("div", { className: "crop" },
                    React.createElement("img", { src: image, alt: label }))) : null,
                checkLabelIsAvailable(label) ? React.createElement("span", null, label) : null)) : null,
            checkChildrenAreAvailable(children) && isMobile() ? (React.createElement("div", { role: "button", className: "arrow-wrapper", onClick: this.activeRow, onKeyDown: this.onKeyPress, "aria-label": "Ouvrir le sous-menu", tabIndex: 0 },
                React.createElement("i", { className: isOpen ? 'arrow open' : 'arrow close' }))) : null,
            checkChildrenAreAvailable(children) ? (React.createElement("ul", __assign({}, listProps), children.map(function (row, childrenIndex) { return (React.createElement(Link, __assign({ key: childrenIndex }, getLinkProps(row, childrenIndex), { onClickAction: _this.props.onClickAction }))); }))) : null));
    };
    return Link;
}(React.Component));
export default Link;
//# sourceMappingURL=Link.js.map